import { render, staticRenderFns } from "./OcrDetailDialog.vue?vue&type=template&id=070146f5&scoped=true&"
import script from "./OcrDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./OcrDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OcrDetailDialog.vue?vue&type=style&index=0&id=070146f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070146f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
